import React, {useState, useEffect} from 'react';

import { withRouter, Link } from 'react-router-dom';
import Button from 'react-bootstrap/Button'; import Form from 'react-bootstrap/Form';
import { useStoreActions, useStoreState } from "easy-peasy";
import { useHistory } from 'react-router-dom';

function SignUp(props) {
  const linkoln_domains = useStoreState(state => state.linkoln_domains.domains);
  const [first_name, setFirstName] = useState('');
  const [last_name, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [email2, setEmail2] = useState('');
  const [signup_code, setSignupCode] = useState('');
  const [accepted_terms, setAcceptedTerms] = useState(false);
  const [is_signed_up, setIsSignedUp] = useState(false);
  const [domain, setDomain] = useState('');
  const [subdomain, setSubDomain] = useState('');
  const signUp = useStoreActions(actions => actions.signUp);
  const is_logged_in = useStoreState(state => state.is_logged_in);
  const getLinkolnDomains = useStoreActions(actions => actions.linkoln_domains.getDomains);
  const history = useHistory();

  useEffect(() => {
    window.scrollTo(0, 0);
    getLinkolnDomains();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    console.log("DOMAINS:");
    console.log(linkoln_domains);
    let thisDomain = linkoln_domains[0];
    console.log(thisDomain);
    setDomain(thisDomain);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [linkoln_domains]);

  useEffect(() => {
    if (is_logged_in) {
      history.push("/");
    }
  }, [is_logged_in, history]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!accepted_terms) {
      alert("You must accept the Terms and Conditions in order to sign up");
      return;
    }
    if (email !== email2) {
        window.alert("Both email fields should match");
		return;
	}
    signUp({email: email, first_name: first_name, last_name: last_name, signup_code: signup_code, domain: domain, subdomain: subdomain})
    .then(response => {
      if (response.success) {
        setIsSignedUp(true)
        if (props.footer) {
          window.alert("Success!  You will receive a link in your email to verify your account.");
        }
      } else if (response.error) {
        window.alert(response.error);
      }
    });
  };

  if (props.footer) {
    return (
                <>
                    <div className="col-md-6 pe-md-5">
                        <h4 className="mb-3">Sign Up For Free</h4>
                        <Form onSubmit={handleSubmit}>
                            <div className="row">
                                <Form.Group className="col-sm-6 mb-3">
                                  <Form.Label className="form-label mb-0">First Name</Form.Label>
                                  <Form.Control type="input" className="form-control" onChange={(e) => setFirstName(e.target.value)} value={first_name}/>
                                </Form.Group>
                                <Form.Group className="col-sm-6 mb-3">
                                  <Form.Label className="form-label mb-0">Last Name</Form.Label>
                                  <Form.Control type="input" className="form-control" onChange={(e) => setLastName(e.target.value)} value={last_name}/>
                                </Form.Group>
                                <Form.Group className="col-sm-6 mb-3">
                                  <Form.Label className="form-label mb-0">Email</Form.Label>
                                  <Form.Control type="input" className="form-control" onChange={(e) => setEmail(e.target.value)} value={email}/>
                                </Form.Group>
                                <Form.Group className="col-sm-6 mb-3">
                                  <Form.Label className="form-label mb-0">Re-enter your Email</Form.Label>
                                  <Form.Control type="input" className="form-control" onChange={(e) => setEmail2(e.target.value)} value={email2}/>
                                </Form.Group>
                                <Form.Group className="col-sm-12 mb-3">
                                  <div className="row">
                                    <div className="col text-center px-0">
                                      <Form.Check onChange={(e) => setAcceptedTerms(e.target.value)} value={accepted_terms}/>
                                    </div>
                                    <div className="col-11 ps-0">
                                      <Form.Label>I agree to the <Link to="/acceptableuse" target="_blank" rel="noreferrer" className="text-danger">Acceptable Use Policy</Link></Form.Label>
                                    </div>
                                  </div>
                                </Form.Group>

                                <Form.Group className="col-sm-12 mb-3">
                                  <button type="submit" className="btn btn-danger btn-lg">Go</button>
                                </Form.Group>
                            </div>
                            <div id="emailHelp" className="form-text my-3">To complete your registration, a confirmation link will be emailed to you.<br/>
                                <br/>*By filling out this form you agree to receive transactional email mesages. We will never sell your information to third parties.</div>
                        </Form>
                    </div>
                    </>
    );
  }

  return (
    <>
    {is_signed_up && (
      <div className="row pt-5">
        <div className="col-12">
        <h2>Almost There!</h2>
        <p>Just one more thing to do.</p>

        <h3>Confirm Your Email Address:</h3>
        <ol>
          <li>Check your inbox (and possibly your quarantine folder) for a confirmation email from no-reply@linkoln.io</li>
          <li>Click the confirmation link inside.</li>
        </ol>
    </div>
    </div>
    )}
    {!is_signed_up && (
      <>

      {/*<div className="container pt-5">
        <div className="row">
            <div className="col text-center">
                <h1 className="text-uppercase">Pricing</h1>
            </div>
        </div>
      </div>

      <section>
        <div className="container py-5">
        <div className="row d-flex">
            <div className="col-md-5 mx-auto shadow mb-4 mb-md-0 p-3 p-md-4 rounded-3 bg-dark text-white border border-light border-2">
                <h2 className="mb-4">Five Dollar Alphas.</h2>
                <ul className="checklist p-0">
                  <li className="h5">Your own private developer account</li>
                  <li className="h5">Dedicated personal domain name.</li>
                  <li className="h5">Formidable new communications superpowers.</li>
                </ul>
                <p className="h5 text-danger text-uppercase mb-0">All just $5 per month.</p>
                <p className="text-muted fst-italic"><small>Alpha pricing is only available for a limited time. Setup fee may apply. </small></p>
            </div>
            <div className="col-md-5 mx-auto shadow mb-4 mb-md-0 p-3 p-md-4 rounded-3 bg-dark text-white border border-light border-2">
                <h2 className="mb-4">Try It Out.</h2>
                <ul className="checklist p-0">
                <li className="h5">Full API access.</li>
                <li className="h5">30 days free. </li>
                <li className="h5">No credit card required.</li>
                </ul>
            </div>
        </div>
        </div>
      </section>*/}
      <div className="row text-center pt-5">
        <div className="col-12">
          {/*<h1 className="font-weight-bold">See For Yourself</h1>*/}
          <h2>Welcome!</h2>
          <h3 className="mb-3">Let's create your Free STARTER account.</h3>
        </div>
      </div>
    <Form id="signup" className="row mx-3 d-flex justify-content-center" onSubmit={handleSubmit}>
      <div className="col-12 col-md-6 mx-auto bg-white shadow rounded py-3 m-3 m-sm-0">
        <Form.Group className="col-12 mb-3">
          <Form.Label>First Name:</Form.Label>
          <Form.Control type="input" onChange={(e) => setFirstName(e.target.value)} value={first_name}/>
        </Form.Group>
        <Form.Group className="col-12 mb-3">
          <Form.Label>Last Name:</Form.Label>
          <Form.Control type="input" onChange={(e) => setLastName(e.target.value)} value={last_name}/>
        </Form.Group>
        <div className="form-text mb-3">Please enter the email address you'll use to communicate with LINKOLN.</div>
        <Form.Group className="col-12 mb-3">
          <Form.Label>Email Address:</Form.Label>
          <Form.Control type="input" onChange={(e) => setEmail(e.target.value)} value={email}/>
        </Form.Group>
        <Form.Group className="col-12 mb-3">
          <Form.Label>Re-enter Email Address:</Form.Label>
          <Form.Control type="input" onChange={(e) => setEmail2(e.target.value)} value={email2}/>
        </Form.Group>
        <h5>Create your own personal LINKOLN domain name.</h5>
        <Form.Group className="row d-flex align-items-start">
          <Form.Group className="col text-start">
            <Form.Label>Create your<br/>Subdomain.</Form.Label>
              <div className="input-group">
                <Form.Control as="input" onChange={(e) => setSubDomain(e.target.value)} value={subdomain}/>
                <span className="input-group-text">.</span>
              </div>
          </Form.Group>
          <Form.Group className="col text-start">
            <Form.Label>Select a LINKOLN<br/>Domain Name:</Form.Label>
              <Form.Select onChange={(e) => setDomain(e.target.value)} value={domain}>
              { linkoln_domains &&
                  linkoln_domains.map(domain => (
                      <option value={domain} key={domain}>{domain}</option>
                  ))
              }
              </Form.Select>
          </Form.Group>
          { false &&
          <Form.Group className="col-12">
            <Button variant="danger btn text-uppercase">Check Availability</Button>
          </Form.Group>
            }
        </Form.Group>
        <Form.Group className="col-12">
          <div className="form-text mt-3">Please provide an early access code to LINKOLN.</div>
          <Form.Label>Access Code</Form.Label>
          <Form.Control type="input" onChange={(e) => setSignupCode(e.target.value)} value={signup_code}/>
        </Form.Group>
        <Form.Group className="col-12 mx-auto my-3">
          <div className="row">
            <div className="col text-center px-0">
              <Form.Check onChange={(e) => setAcceptedTerms(e.target.value)} value={accepted_terms}/>
            </div>
            <div className="col-11 ps-0">
              <Form.Label>I agree to the <Link to="/acceptableuse" target="_blank" rel="noreferrer">Acceptable Use Policy</Link></Form.Label>
            </div>
          </div>
        </Form.Group>


        <div className="col-12">
          <Button type="submit" variant="danger btn-lg w-100 text-uppercase mt-4">Create Free STARTER Account</Button>
        </div>
      </div>
    </Form>
    <div className="row">
    <div className="col-md-6 mx-auto">
      <p className="text-center text-body mt-3">
          <small>To complete your registration, a confirmation link will be emailed to you.<br/>We will never sell your information to third parties.<br/>
          Already signed up? <Link to="/log_in" className="text-reset"><u>Login here</u></Link></small>
      </p>
</div>
</div>
      </>
    )}
    </>
  );
}

export default withRouter(SignUp);
